import React from 'react';
import '../pages/Services.css';

const Footer = () => (
  <footer className="simple-footer">
    <div>© {new Date().getFullYear()} HRZ Landscaping. All rights reserved.</div>
  </footer>
);

export default Footer;
